import requestingAgency from './requesting-agency.middleware';
import serviceLevel from './service-level.middleware';
import patientAdditionalInfo from './patient-additional-info.middleware';
import map from './map.middleware';
import saveButton from './orders/saveButton.middleware';

const componentsMiddleware = [...requestingAgency, ...serviceLevel, ...patientAdditionalInfo, ...map, ...saveButton];

export default componentsMiddleware;
